import { CurrencyDisplay } from "components";
import { Box, Grid, styled, Typography } from "@mui/material";

const ReportSummaryCard = ({ title, value, isCurrency, hidden, maxWidth }) =>
  !hidden && (
    <SummaryCard maxWidth={maxWidth}>
      <SummaryTitle>{title}</SummaryTitle>
      <SummaryValue>
        <CurrencyDisplay
          value={value}
          decimalScale={isCurrency && value && 2}
          prefix={isCurrency && "Rp"}
        />
      </SummaryValue>
    </SummaryCard>
  );

const RoyaltyTrackingSummarytCard = ({ chartReport }) => {
  const reportSummaryList = [
    {
      title: "Total Revenue",
      value: chartReport?.total_composer_revenue || 0,
      isCurrency: true,
    },
    {
      title: "Paid",
      value: chartReport?.total_paid || 0,
      isCurrency: true,
    },
    {
      title: "Unpaid",
      value: chartReport?.total_unpaid || 0,
      isCurrency: true,
    },
  ];
  return (
    <Grid container justifyContent={"flex-end"}>
      {reportSummaryList?.map((item, key) => (
        <Grid key={key} item xs={3}>
          <ReportSummaryCard
            title={item?.title}
            value={item?.value}
            isCurrency={item?.isCurrency}
            hidden={item?.hidden}
            maxWidth={item?.maxWidth}
          />
        </Grid>
      ))}
    </Grid>
  );
};

const SummaryCard = styled(Box)(({ maxWidth }) => ({
  borderRight: "1px solid gray",
  paddingRight: "20px",
  maxWidth: maxWidth,
}));
const SummaryTitle = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 500,
  color: "#687083",
  textAlign: "right",
}));
const SummaryValue = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: 500,
  color: "#111827",
}));
export default RoyaltyTrackingSummarytCard;
